import { useEffect } from "react";
import { AiOutlineDelete } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import io from "socket.io-client";
import { LoadingSpinerGif, Sx_Download } from "../../../assets/icons";
import {
  addNotification,
  addNotifications,
} from "../../../Redux/actions/commonActtion";
import {
  deleteAllRenders,
  deleteRenders,
  downloadCardRender,
  downloadRender,
  getProjectDetails,
} from "../../../Redux/actions/projectActions";
import {
  getfpsFromNumAndDen,
  getRenderStatus,
  getResolutionFromHeightAndWidth,
} from "./render.constants";
import Styles from "./Render.module.css";
import CustomToast from "../../../Components/CustomToast/CustomToast";
import { customToatStyle } from "../Options/OptionBlocks/Logos/Logos";

const hostname = window.location.hostname;
let url;

if (hostname === "dev.scrollx.io") {
  url = "https://dev.api.scrollx.io";
} else if (hostname === "localhost") {
  url = "http://localhost:8000";
} else {
  url = "https://api.scrollx.io";
}

const socket = io(url);
const RendersTable = ({ isCard }) => {
  const user = JSON.parse(localStorage.getItem("user"));
  const dispatch = useDispatch();
  const {
    isLoading,
    renders,
    _id: projectId,
    members, // Assuming this exists in state
  } = useSelector((state) => state?.project || {});

  useEffect(() => {
    if (!projectId) return;

    socket.emit("join-project-room", {
      projectId: projectId,
    });

    socket.on("render-update", (data) => {
      dispatch(getProjectDetails(projectId, isCard));
      // Construct a notification object similar to what your API returns
      const notification = {
        project_id: data?.projectId,
        render_id: data?.renderId,
        message: `Render got completed for project ${data?.title}.`,
        status: 1,
        user_id: user._id,
        createdAt: new Date().toISOString(),
      };
      dispatch(addNotification(notification?.message));
      toast(
        <CustomToast
          title=""
          content={`Render got completed for project ${data?.title}.`}
        />,
        customToatStyle
      );
    });

    return () => {
      socket.off("render-update");
    };
  }, [projectId, dispatch]);

  const downLoadVideo = async (renderId) => {
    const urlRes = isCard
      ? await dispatch(downloadCardRender(projectId, renderId))
      : await dispatch(downloadRender(projectId, renderId));

    if (urlRes?.success) {
      window.open(urlRes?.data?.downloadURL);
    } else {
      toast.error("URL Not Exist");
    }
  };

  const deleteRender = (renderId) => {
    if (
      window.confirm(`Are you sure you want to delete Render (${renderId})?`)
    ) {
      dispatch(deleteRenders(projectId, renderId, isCard));
    }
  };

  const clearHistory = async () => {
    if (window.confirm("Are you sure you want to delete All Renders?")) {
      const res = await dispatch(deleteAllRenders(projectId));
      toast.success(res?.message);
    }
  };

  useEffect(() => {
    dispatch(getProjectDetails(projectId, isCard));
  }, [projectId]);

  return (
    <div className="w-full h-full pt-[1%]">
      {/* <div className="flex justify-between items-center pl-[5%] pr-[5.5%]">
            <h3 className={Styles.rendHistory}>RENDER HISTORY</h3>
            <button
                type="button"
                onClick={clearHistory}
                disabled={renders?.length < 1}
                style={{
                    outline: "1px solid var( --white-20)",
                    borderRadius: "0.5rem",
                    color: "var(--white-80)",
                    backgroundColor: "#4e4e4e",
                    fontSize: "12px",
                    padding: "4px 22px",
                    transition: "all .3s ease",
                    cursor: renders?.length < 1 ? "not-allowed" : "pointer",
                    opacity: renders?.length < 1 ? 0.5 : 1,
                }}
            >
                Clear history
            </button>
        </div> */}

      <div
        className={`${Styles.historytabel} overflow-y-auto h-[400px] relative`}
      >
        <table className="relative" width="100%">
          <thead className="h-[55px] w-full bg-[#333] text-white sticky top-0 shadow-md">
            <tr className="text-xl drop-shadow-2xl ">
              <th>Version</th>
              <th>Created</th>
              <th>Resolution</th>
              <th>Format</th>
              <th>FPS</th>
              <th>Aspect Ratio</th>
              <th>Status</th>
              <th>Download</th>
              <th>Delete</th>
            </tr>
          </thead>

          <tbody className="text-lg">
            {renders?.map((render, idx) => {
              // console.log('render table => ',render);
              return (
                render && (
                  <tr
                    key={idx}
                    className={`${idx % 2 === 0 ? "" : ""} ${Styles.test11}`}
                  >
                    <td>{idx + 1}</td>

                    <td>
                      {new Date(render?.createdAt).toDateString()} -{" "}
                      {new Date(render?.createdAt).toTimeString()?.slice(0, 5)}
                    </td>

                    <td>
                      {getResolutionFromHeightAndWidth(
                        render?.videoHeight,
                        render?.videoWidth
                      )}
                    </td>

                    <td>{render?.format}</td>

                    <td>
                      {getfpsFromNumAndDen(
                        render?.fpsNumerator,
                        render?.fpsDenominator
                      )}
                    </td>

                    <td>{render?.aspectRatio}</td>

                    <td>{getRenderStatus(render)}</td>

                    <td>
                      {render?.isVideoGenerated ? (
                        <span
                          className="cursor-pointer flex items-center justify-center"
                          onClick={() => downLoadVideo(render._id)}
                        >
                          <img className="w-7" src={Sx_Download} alt="" />
                        </span>
                      ) : (
                        <span className="flex items-center justify-center">
                          {/* <FaSpinner className="animate-spin inline" size={20} /> */}
                          <img className="w-7" src={LoadingSpinerGif} alt="" />
                        </span>
                      )}
                    </td>

                    <td>
                      <span
                        className="cursor-pointer"
                        onClick={() => deleteRender(render?._id)}
                      >
                        <AiOutlineDelete className="inline" size={20} />
                      </span>
                    </td>
                  </tr>
                )
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default RendersTable;
